<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import ChatMessage from './ChatMessage.vue';
    import ChatMessageRows from './ChatMessageRows.vue';

    defineProps<{ message: IChatMessage }>();
</script>

<template>
    <ChatMessage :message="message" :rating="false">
        <ChatMessageRows :message="message" />
    </ChatMessage>
</template>
